// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15nFs","col":"styles_col__30NHf"};